module.exports = ".highChartDefalutCSS {\r\n  min-width: 310px;\r\n  height: 400px;\r\n  margin: 0 auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/my-charts/my-charts.component.css
// module id = ./src/app/components/my-charts/my-charts.component.css
// module chunks = main